
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { lessonService } from '@/services';
import { Lesson } from '@/models/Lesson';

export const useLessonMutation = (userId: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ lessonId }: { userId: string, lessonId: string, completed: boolean }) => {
      console.log('⚠️ Lesson updates are now handled via activity logs only. Direct lesson document updates have been disabled.');
      // Return a resolved promise to prevent errors
      return Promise.resolve(true);
    },
    onSuccess: () => {
      if (userId) {
        // Still invalidate queries to refresh data
        queryClient.invalidateQueries({ queryKey: ['lessons', userId] });
      }
    },
  });
};
